import { createTheme } from '@mui/material/styles';
import { colors } from '../styles/colors.js';
import shippoTheme from '../styles/shippoTheme.js';

var dividerTheme = createTheme(shippoTheme, {
    MuiDivider: {
        styleOverrides: {
            backgroundColor: colors.borders,
        },
    },
});

export { dividerTheme as default };
//# sourceMappingURL=Divider.theme.js.map
